import {computed, reactive, ref} from 'vue';

export function useErrors() {
    const errors = ref([]);
    const any = computed(() => errors.value.length > 0);

    function get(field) {
        return errors.value.find(([f]) => f === field)?.at(1);
    }

    function set(field, messages) {
        errors.value.push([field, messages]);
    }

    function has(field) {
        return !!get(field);
    }

    /**
     * @param {Record<string, Array>} errors
     */
    function record(errors) {
        Object.entries(errors).forEach(([field, messages]) => set(field, messages));
    }

    function clear() {
        errors.value = [];
    }

    return {
        has,
        any,
        get,
        record,
        clear,
    };
}
